module.exports = __webpack_public_path__ + "img/elevance-health.90708e14.jpg";